// extracted by mini-css-extract-plugin
export var bubble = "_3a-0";
export var container = "_3a-3";
export var contrastBorder = "_3a-4";
export var greyOut = "_3a-2";
export var initialsWrapper = "_3a-1";
export var large = "_3a-9";
export var medium = "_3a-8";
export var mediumSmall = "_3a-7";
export var mediumSmallMedium = "_3a-c";
export var micro = "_3a-5";
export var small = "_3a-6";
export var tiny = "_3a-b";
export var xTiny = "_3a-a";